import React from 'react'
import DailyAttendanceList from '../components/DailyAttendanceList';
import ALLLeaveRequestList from '../components/AllLeaveRequestList';
import HRMSLayout from '../../../../../layout/components/HRMSLayout';


function AttendanceDashboardPage() {

  return (
    <HRMSLayout>
      <div className='row'>
        <div className='col-md-6'>
          <DailyAttendanceList />
        </div>
        <div className='col-md-6'>
          <ALLLeaveRequestList />
        </div>
      </div>
    </HRMSLayout>
  )
}

export default AttendanceDashboardPage